<template>
  <HeaderComponent />
  <div class="fixed top-[80px] left-[50%] z-[100] translate-x-[-50%] w-[80%] max-w-[400px] flex flex-col">
    <div v-if="errorMessage" class="text-sm w-full rounded-[5px] shadow-4xl text-white bg-red-700 my-[10px] font-bold text-center p-[20px]">{{ errorMessage }}</div>
    <div v-if="successMessage" class="text-sm w-full rounded-[5px] shadow-4xl text-white bg-green-700 my-[10px] font-bold text-center p-[20px]">{{ successMessage }}</div>
  </div>

  <section class="w-full min-h-screen pt-[120px] pb-[60px] bg-gray-100 flex justify-center items-start">
    <div class="container lg:max-w-[1200px] px-[20px] flex justify-center w-full">
      <div class="w-full max-w-[420px] bg-white rounded-[10px] shadow-4xl overflow-hidden">
        <div class="w-full bg-orange-600 p-[25px] flex flex-col items-center">
          <img src="../assets/logo.png" alt="" class="w-[50px] h-[50px] mb-[10px]">
          <h1 class="text-white text-xl font-bold">Connexion</h1>
          <p class="text-orange-100 text-xs mt-[5px]">Accédez à votre espace client</p>
        </div>
        <form @submit.prevent="login" class="w-full p-[25px]">
          <div class="w-full my-[10px]">
            <label class="text-sm font-bold text-gray-700 mb-[5px] block">Numéro WhatsApp</label>
            <input v-model="whatsapp" type="tel" required class="w-full p-[12px] outline-none text-sm font-semibold rounded-[5px] bg-gray-100 focus:ring-2 focus:ring-orange-500" placeholder="Ex: 0166519432">
          </div>
          <div class="w-full my-[10px]">
            <div class="flex justify-between items-center mb-[5px]">
              <label class="text-sm font-bold text-gray-700 block">Mot de passe</label>
              <router-link to="/mot-de-passe-oublie" class="text-xs text-orange-600 font-semibold hover:underline">Mot de passe oublié ?</router-link>
            </div>
            <input v-model="password" type="password" required class="w-full p-[12px] outline-none text-sm font-semibold rounded-[5px] bg-gray-100 focus:ring-2 focus:ring-orange-500" placeholder="Votre mot de passe">
          </div>
          <button type="submit" :disabled="isLoading" class="w-full h-[48px] mt-[15px] flex justify-center items-center p-[10px] text-sm font-bold rounded-[5px] bg-orange-600 hover:bg-orange-700 text-gray-100 transition-colors">
            <span v-if="!isLoading">Se connecter</span>
            <div v-else class="spinner1"><div></div><div></div><div></div><div></div><div></div></div>
          </button>
          <p class="text-center text-sm text-gray-500 mt-[20px]">
            Pas encore de compte ?
            <router-link to="/inscription" class="text-orange-600 font-bold hover:underline">Inscrivez-vous</router-link>
          </p>
        </form>
      </div>
    </div>
  </section>
  <FooterComponent />
</template>

<script setup>
import HeaderComponent from '../components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import axios from 'axios'
import { useAuthClientStore } from '@/store/useAuthClientStore'

const router = useRouter()
const route = useRoute()
const authClientStore = useAuthClientStore()

const whatsapp = ref('')
const password = ref('')
const isLoading = ref(false)
const errorMessage = ref('')
const successMessage = ref('')

const login = async () => {
  isLoading.value = true
  try {
    const { data } = await axios.post('/api/clients/login', { whatsapp: whatsapp.value, password: password.value })
    authClientStore.setAuth(data.token, data.client)
    successMessage.value = 'Connexion réussie !'
    const redirect = route.query.redirect || '/mon-espace'
    setTimeout(() => router.push(redirect), 500)
  } catch (error) {
    errorMessage.value = error.response?.data?.error || 'Erreur lors de la connexion.'
    setTimeout(() => (errorMessage.value = ''), 4000)
  } finally {
    isLoading.value = false
  }
}
</script>
